import { Method } from 'axios';
import { Executable } from './executable';

/**
 * The UploadBase64ImageInput used by the constructor of UploadBase64Image
 */
export interface UploadBase64ImageInput {
  /**
   * The Base64 Encoded image string
   */
  image: string;
}

/**
 * The UploadBase64Image response expected from the execution of the object within BambuClient execute.
 */
export interface UploadBase64ImageResponse {
  /**
   * the uploaded image ipfs url
   */
  ipfsUrl: string;
  /**
   * the message response from the request in case of errors
   */
  message?: string;
  /**
   * any error messages that were returned by the request.
   */
  error?: any;
}

export class UploadBase64Image extends Executable<UploadBase64ImageResponse> {
  public payload: UploadBase64ImageInput;

  /**
   * getMethod is used by the BambuClient to properly construct the request call.
   * @returns request method
   */
  public getMethod(): Method {
    return 'post';
  }

  /**
   * getResponse is used by the BambuClient to propery return the response object type.
   * @param apiResponse the api response object returned by the BambuMeta client before being converted to the UploadBase64ImageResponse
   * @returns UploadBase64ImageResponse
   */
  public getResponse(apiResponse: any): UploadBase64ImageResponse {
    return apiResponse;
  }

  /**
   * getURLPath is used by the BambuClient to properly construct the request call.
   * @param tenantId the tenant id defined in the BambuClient
   * @returns request url
   */
  public getURLPath(tenantId?: string): string {
    return `${tenantId}/files/upload-base64-image`;
  }

  constructor(input: UploadBase64ImageInput) {
    super();
    this.payload = input;
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): any {
    const input = this.payload;
    return input;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return undefined;
  }
}
